import { sendEvent } from '@utils/core/track';
import AcIcon from 'ac-components/ac-icon';
import classnames from 'classnames';
import React, { useState } from 'react';
import { MenuItem } from './const';
import styles from './styles.scss';

type MenuProps = {
	list: MenuItem[];
	onSelect(item: MenuItem): void;
	menu?: MenuItem;
	transData: any;
}

export default function Menu(props: MenuProps) {
	const { list, onSelect, transData, menu: activeMenu } = props;
	const [curMenu, setMenu] = useState(activeMenu);
	const onClickHandle = (menu: MenuItem) => {
		const { eventId } = menu;
		onSelect(menu);
		setMenu(menu)
		if (eventId) sendEvent({ eventId });
	}

	return (
		<menu className={styles.menu}>
			<ul>
				{
					list.map(menu => {
						return (
							<li
								className={classnames(styles.menu_item, curMenu?.name == menu?.name ? styles.menu_item_active : '')}
								key={menu.name}
								onClick={() => onClickHandle(menu)}
							>
								{menu.icon && <AcIcon icon={menu.icon} />}
								<span>{transData[menu.label]}</span>
							</li>
						)
					})
				}
			</ul>
		</menu>
	)
}
